export default "<div class=\"vle-filter-list\">\n  <ng-content></ng-content>\n</div>\n";